import type { Island } from "./types";

/**
 * Stars per island. Three stars are the proven optimum — nothing less.
 * Two stars mark the deterministic greedy baseline (the "obvious play",
 * re-derived in levels.test.ts); on island 1 greedy IS optimal, so the
 * two-star bar relaxes to 85% there.
 */
export function starsFor(value: number, island: Island): number {
  if (value >= island.opt) return 3;
  const two = island.greedy < island.opt ? island.greedy : Math.ceil(island.opt * 0.85);
  return value >= two ? 2 : 1;
}

export function gapLine(value: number, opt: number): string {
  const gap = opt - value;
  if (gap <= 0) return "You matched the proven optimum — not a coin more would fit.";
  const pct = opt > 0 ? Math.round((value / opt) * 100) : 0;
  return `${gap} gold stayed on the quay that didn't have to (you loaded ${pct}% of the proven best).`;
}
